// Types for the async bulk offer-update flow (see OfferUpdateController on the API).

export enum OfferUpdateType {
  BestOfferReset = 0,
  Title = 1,
  Policy = 2,
}

// Returned immediately when any offer-update is queued.
export interface IOfferUpdateQueueResult {
  batchId: string | null;
  queued: number;
  skipped: number;
}

export type OfferUpdateItemStatus = "Pending" | "Processing" | "Success" | "Failed";

export interface IOfferUpdateBatchItemStatus {
  id: string;
  type: OfferUpdateType;
  partOfferId: string;
  partDataId: string;
  sku: string | null;
  title: string | null;
  newAutoAcceptPrice: number | null;
  isProcessing: boolean;
  isSuccess: boolean;
  errorMessage: string | null;
  status: OfferUpdateItemStatus;
}

export interface IOfferUpdateBatchStatus {
  batchId: string;
  type: OfferUpdateType;
  isComplete: boolean;
  total: number;
  succeeded: number;
  failed: number;
  processing: number;
  pending: number;
  items: IOfferUpdateBatchItemStatus[];
}
